<template>
    <app-primary> 
        <template #subHead>
            <sub-visual sh="Recent Insights">
                <template #titHead>S</template>
                <template #tit>uccess Story</template>
            </sub-visual>
        </template>
        <page-section class="page-section--first page-section--last">
            <recent-list/>
        </page-section>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubVisual from "@/sets/styles/sub/sub-visual.vue";
import PageSection from "@/sets/styles/pages/page-section.vue";
import RecentList from "@/components/client/board/skin/recent/list.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
import UTxtMedium from "@/components/publish/styles/typography/u-txt-medium.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UTitMedium from "@/components/publish/styles/typography/u-tit-medium.vue";

export default {
    components: {
        AppPrimary,
        SubVisual,
        PageSection,
        RecentList,
        UTxtDefault,
        UTxtMedium,
        UTitDefault,
        UTitMedium,
    },
}
</script>

<style lang="scss" scoped></style>
